import { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { Flex, CardFooter, ExpandableLabel, Pool } from '@pancakeswap/uikit'
import { Token } from '@pancakeswap/sdk'
import PoolStatsInfo from '../../PoolStatsInfo'

interface FooterProps {
  pool: Pool.DeserializedPool<Token>
  account: string
  totalCakeInVault?: BigNumber
  defaultExpanded?: boolean
  isLocked?: boolean
}

const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  button {
    padding: 0;
  }
`
const ExpandedWrapper = styled(Flex)`
  svg {
    height: 14px;
    width: 14px;
  }
`

const Footer: React.FC<React.PropsWithChildren<FooterProps>> = ({
  pool,
  account,
  defaultExpanded,
  children,
}) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

  return (
    <CardFooter>
      <ExpandableButtonWrapper>
        <Flex justifyContent="center">
          <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t('Hide') : t('Details')}
        </ExpandableLabel>
        </Flex>
        
      </ExpandableButtonWrapper>
      {isExpanded && (
        <ExpandedWrapper flexDirection="column">
          {children || <PoolStatsInfo pool={pool} account={account} />}
        </ExpandedWrapper>
      )}
    </CardFooter>
  )
}

export default Footer
